import { render, staticRenderFns } from "./Sitesettings.vue?vue&type=template&id=f2db0370&scoped=true&"
import script from "./Sitesettings.vue?vue&type=script&lang=js&"
export * from "./Sitesettings.vue?vue&type=script&lang=js&"
import style0 from "./Sitesettings.vue?vue&type=style&index=0&id=f2db0370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2db0370",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
